// @ts-nocheck
import apiFetch from './supabaseClient';
import type { Database, TaskCategory } from '../types/database';

// Tasks
export const createTask = async (task: Database['public']['Tables']['tasks']['Insert']) => {
  return apiFetch('/tasks', { method: 'POST', body: task });
};

export const updateTask = async (id: string, task: Database['public']['Tables']['tasks']['Update']) => {
  return apiFetch(`/tasks/${id}`, { method: 'PATCH', body: { ...task, modified_at: new Date().toISOString() } });
};

export const deleteTask = async (id: string) => {
  return apiFetch(`/tasks/${id}`, { method: 'DELETE' });
};

export const getTasks = async (category?: TaskCategory, userId?: string) => {
  const params = new URLSearchParams();
  if (category) params.set('category', category);
  if (userId) params.set('user_id', userId);
  const qs = params.toString();
  return apiFetch(`/tasks${qs ? `?${qs}` : ''}`);
};

export const getSubtasks = async (parentId: string) => {
  return apiFetch(`/tasks?parent_id=${parentId}`);
};

// Notebooks
export const createNotebook = async (notebook: Database['public']['Tables']['notebooks']['Insert']) => {
  return apiFetch('/notebooks', { method: 'POST', body: notebook });
};

export const updateNotebook = async (id: string, notebook: Database['public']['Tables']['notebooks']['Update']) => {
  return apiFetch(`/notebooks/${id}`, { method: 'PATCH', body: notebook });
};

export const deleteNotebook = async (id: string) => {
  return apiFetch(`/notebooks/${id}`, { method: 'DELETE' });
};

export const getNotebooks = async () => {
  return apiFetch('/notebooks');
};

// Notes
export const createNote = async (note: Database['public']['Tables']['notes']['Insert']) => {
  return apiFetch('/notes', { method: 'POST', body: note });
};

export const updateNote = async (id: string, note: Database['public']['Tables']['notes']['Update']) => {
  return apiFetch(`/notes/${id}`, { method: 'PATCH', body: { ...note, modified_at: new Date().toISOString() } });
};

export const deleteNote = async (id: string) => {
  return apiFetch(`/notes/${id}`, { method: 'DELETE' });
};

export const getNotes = async (notebookId: string) => {
  return apiFetch(`/notes?notebook_id=${notebookId}`);
};

// Projects
export const createProject = async (project: any) => {
  return apiFetch('/projects', { method: 'POST', body: project });
};

export const updateProject = async (id: string, project: any) => {
  return apiFetch(`/projects/${id}`, { method: 'PATCH', body: { ...project, updated_at: new Date().toISOString() } });
};

export const deleteProject = async (id: string) => {
  return apiFetch(`/projects/${id}`, { method: 'DELETE' });
};

export const getProjects = async () => {
  return apiFetch('/projects');
};

// Ideas
export const createIdea = async (idea: Database['public']['Tables']['ideas']['Insert']) => {
  return apiFetch('/ideas', { method: 'POST', body: idea });
};

export const updateIdea = async (id: string, idea: Database['public']['Tables']['ideas']['Update']) => {
  return apiFetch(`/ideas/${id}`, { method: 'PATCH', body: { ...idea, modified_at: new Date().toISOString() } });
};

export const deleteIdea = async (id: string) => {
  return apiFetch(`/ideas/${id}`, { method: 'DELETE' });
};

export const getIdeas = async () => {
  return apiFetch('/ideas');
};

// Idea Features
export const createIdeaFeature = async (feature: Database['public']['Tables']['idea_features']['Insert']) => {
  const payload = { type: 'feature', ...feature };
  return apiFetch('/idea-features', { method: 'POST', body: payload });
};

export const updateIdeaFeature = async (id: string, feature: Database['public']['Tables']['idea_features']['Update']) => {
  return apiFetch(`/idea-features/${id}`, { method: 'PATCH', body: feature });
};

export const deleteIdeaFeature = async (id: string) => {
  return apiFetch(`/idea-features/${id}`, { method: 'DELETE' });
};

export const getIdeaFeatures = async (ideaId: string, type?: string) => {
  const params = new URLSearchParams({ idea_id: ideaId });
  if (type) params.set('type', type);
  return apiFetch(`/idea-features?${params}`);
};

// Decisions
export const createDecision = async (decision: any) => {
  return apiFetch('/decisions', { method: 'POST', body: decision });
};

export const updateDecision = async (id: string, decision: any) => {
  return apiFetch(`/decisions/${id}`, { method: 'PATCH', body: { ...decision, updated_at: new Date().toISOString() } });
};

export const deleteDecision = async (id: string) => {
  return apiFetch(`/decisions/${id}`, { method: 'DELETE' });
};

export const getDecisions = async (userId: string) => {
  return apiFetch(`/decisions?user_id=${userId}`);
};

export const getSubDecisions = async (parentId: string) => {
  return apiFetch(`/decisions?parent_id=${parentId}`);
};

// Decision Options
export const createDecisionOption = async (option: any) => {
  return apiFetch('/decision-options', { method: 'POST', body: option });
};

export const updateDecisionOption = async (id: string, option: any) => {
  return apiFetch(`/decision-options/${id}`, { method: 'PATCH', body: { ...option, updated_at: new Date().toISOString() } });
};

export const deleteDecisionOption = async (id: string) => {
  return apiFetch(`/decision-options/${id}`, { method: 'DELETE' });
};

export const getDecisionOptions = async (decisionId: string) => {
  return apiFetch(`/decision-options?decision_id=${decisionId}`);
};

// Decision Option Points
export const createDecisionOptionPoint = async (point: any) => {
  return apiFetch('/decision-option-points', { method: 'POST', body: point });
};

export const updateDecisionOptionPoint = async (id: string, point: any) => {
  return apiFetch(`/decision-option-points/${id}`, { method: 'PATCH', body: point });
};

export const deleteDecisionOptionPoint = async (id: string) => {
  return apiFetch(`/decision-option-points/${id}`, { method: 'DELETE' });
};

export const getDecisionOptionPoints = async (optionId: string, type?: 'pro' | 'con') => {
  const params = new URLSearchParams({ option_id: optionId });
  if (type) params.set('type', type);
  return apiFetch(`/decision-option-points?${params}`);
};
